import React, { useState, useEffect } from 'react';
import { Container, Keyvalue } from './styles';
import { Button } from '@gerdau/hefesto';
import { RewardBeneficiary } from '..';
import { ApplicationState } from '../../../../../../store';
import { useSelector, useDispatch } from 'react-redux';
import { loadLoyaltySendWithdraw } from '../../../../../../store/ducks/loyalty/actions';
import {
  ILoyaltySendWithdrawBody,
  ILoyaltyWithdrawBeneficiary
} from '../../../../../../store/ducks/loyalty/types';

interface coinTotalResume {
  type: string;
  value: string;
}

interface CoinTotalsProps {
  beneficiaries: RewardBeneficiary[];
  dataConfirmed: boolean;
  setDataConfirmed: (isDataConfirmed: boolean) => void;
  setSuccess: (success: boolean) => void;
}
const CoinTotals: React.FC<CoinTotalsProps> = ({
  beneficiaries,
  dataConfirmed,
  setDataConfirmed,
  setSuccess
}) => {
  const getButtonText = () => {
    if (loyalty.send_withdraw.loading) {
      return 'Enviando dados';
    } else if (dataConfirmed) {
      return 'Finalizar resgate';
    } else if (disableButton()) {
      return 'Para confirmar, preencha os dados';
    } else {
      return 'Confirmar';
    }
  };

  const user = useSelector((appState: ApplicationState) => appState.user);
  const dispatch = useDispatch();

  const loyalty = useSelector((appState: ApplicationState) => appState.loyalty);
  const coinsBalance = loyalty.rewards.total.total_coins;

  const [totalWithdraw, setTotalWithdraw] = useState(0);
  useEffect(() => {
    let sum = 0;
    beneficiaries.map((elem) => {
      sum += Number(elem.rewardValue);
    });
    setTotalWithdraw(Number(sum.toFixed(2)));
  }, beneficiaries);

  const finalTotalWithdraw =
    totalWithdraw > 0 ? `-${totalWithdraw.toString()}` : '0';
  const getTargetAwards = () => {
    const totalResume: coinTotalResume[] = [];
    beneficiaries.map((beneficiary) => {
      let isAdd = false;
      if (totalResume.length == 0) {
        totalResume.push({
          type: beneficiary.rewardType,
          value: beneficiary.rewardValue
        });
      } else {
        totalResume.map((item, idx) => {
          if (item.type == beneficiary.rewardType) {
            let newValue = (
              Number(item.value) + Number(beneficiary.rewardValue)
            ).toFixed(2);
            if (newValue.slice(-3) === '.00') {
              newValue = newValue.slice(0, -3);
            }
            totalResume[idx] = {
              type: item.type,
              value: newValue
            };
            isAdd = true;
          } else if (!isAdd && idx == totalResume.length - 1) {
            totalResume.push({
              type: beneficiary.rewardType,
              value: beneficiary.rewardValue
            });
          }
        });
      }
    });
    return totalResume;
  };
  const finalBalance: number = coinsBalance - totalWithdraw;
  const disableButton = () => {
    if (loyalty.send_withdraw.loading) {
      return true;
    } else if (dataConfirmed) {
      return false;
    } else {
      let disabled = false;
      beneficiaries.map((item) => {
        if (
          item.address == '' ||
          item.companyName == '' ||
          item.companyTaxVat.length != 18 ||
          item.phone == '' ||
          item.phone.length != 11 ||
          item.rewardType == ''
        ) {
          disabled = true;
        }
      });
      return disabled;
    }
  };
  const getAllElementTypeResume = () => {
    const allElementTypes: string[] = [];
    beneficiaries.map((item) => {
      if (allElementTypes.findIndex((elem) => elem == item.rewardType) == -1) {
        allElementTypes.push(item.rewardType);
      }
      return true;
    });
    return allElementTypes;
  };
  useEffect(() => {
    setSuccess(loyalty.send_withdraw.success);
  }, [loyalty.send_withdraw.loading]);

  const getSendWithdrawBody = () => {
    const beneficiariesBody: ILoyaltyWithdrawBeneficiary[] = [];
    beneficiaries.map((item) => {
      beneficiariesBody.push({
        order_type: item.rewardType,
        name: item.companyName,
        cnpj: item.companyTaxVat,
        address: item.address,
        phone: item.phone,
        card_value: Number(item.rewardValue)
      });
    });
    const body: ILoyaltySendWithdrawBody = {
      email: user.email,
      beneficiaries: beneficiariesBody
    };
    return body;
  };
  return (
    <Container>
      <Keyvalue>
        <div className="keys">
          <p>Saldo anterior</p>
          <p>Total resgatado</p>

          <div className="sub-keys">
            {getAllElementTypeResume().map((elem) => {
              return <p>{elem}</p>;
            })}
          </div>
        </div>
        <div className="values">
          <p className="bold">{coinsBalance}</p>
          <p className="bold">{finalTotalWithdraw}</p>
          {getTargetAwards().map((elem) => {
            return <p>{elem.value}</p>;
          })}
        </div>
      </Keyvalue>
      <div className="sub-line">
        <hr />
      </div>
      <Keyvalue>
        <div>
          <p>Saldo final</p>
        </div>
        <div className="values">
          <p className="bold">{finalBalance}</p>
        </div>
      </Keyvalue>
      <div className="submitButton activeButton">
        <Button
          disabled={disableButton()}
          name="form"
          onClick={() => {
            if (dataConfirmed) {
              dispatch(
                loadLoyaltySendWithdraw(
                  user.roles.loyaltyCustomers
                    ? user.roles.loyaltyCustomers
                    : [],
                  getSendWithdrawBody()
                )
              );
            } else {
              setDataConfirmed(true);
            }
          }}
        >
          {getButtonText()}
        </Button>
      </div>
    </Container>
  );
};

export default CoinTotals;
